import Vue from 'vue'
import VueRouter from 'vue-router'
import { auth } from '../plugins/firebase'

Vue.use(VueRouter)

const routes = [
	{
		path: '/login',
		name: 'Login',
		component: () => import("../views/Login.vue")
    },
    {
        path: '/map/:id',
        name: 'Map',
        component: () => import("../views/Map.vue"),
        meta: { requiresAuth: true },
    },
    {
        path: '/circuit/:id',
        name: 'Circuit',
        component: () => import("../views/Circuit.vue"),
        meta: { requiresAuth: true },
    },
    {
        path: '/schedule/:id',
        name: 'Schedule',
        component: () => import("../views/Schedule.vue"),
        meta: { requiresAuth: true },
    },
    {
        path: '/meter/:id',
        name: 'Meter',
        component: () => import("../views/Meter.vue"),
        meta: { requiresAuth: true },
    },
    {
        path: '/',
        name: 'Main',
        component: () => import("../views/Main.vue"),
        meta: { requiresAuth: true },
    },
    {
        path: '/statuscircuit/:id',
        name: 'StatusCircuit',
        component: () => import("../views/StatusCircuit.vue"),
        meta: { requiresAuth: true },
    },
    {
        path: '/groupmap/:id',
        name:'GroupMap',
        component: () => import("../views/GroupMap.vue"),
        meta: { requiresAuth: true },
    },
    {
        path: '/settings',
        name:'Settings',
        component: () => import("../views/Settings.vue"),
        meta: { requiresAuth: true },
    },
    {
        path: '/groupview/:id',
        name: 'GroupCircuit',
        component: () => import("../views/GroupCircuit.vue"),
        meta: { requiresAuth: true },
    }
]

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes,
})

router.beforeEach((to, from, next) =>{
	const requiresAuth = to.matched.some( r => r.meta.requiresAuth )

	requiresAuth && !auth.currentUser
		? next('/login')
        : next()
        
})

export default router
